import {Button} from "flowbite-react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleCheck} from "@fortawesome/free-solid-svg-icons";
import {faCircle} from "@fortawesome/free-regular-svg-icons";
import React from "react";
import {DeepPartial} from "flowbite-react/dist/types/types";
import {FlowbiteButtonTheme} from "flowbite-react/dist/types/components/Button/Button";
import {DeliverableGroupKey, FeatureKey, UserSurveyStatusModelForFeatureLane} from "data/models/feature-lane";
import clsx from "clsx";
import {surveyQuestionPath} from "hooks/page-navigation/survey";
import {useNavigate} from "react-router-dom";

export type FeatureLaneButtonProps = {
  deliverableGroupId: DeliverableGroupKey;
  featureId: FeatureKey;
  userSurvey: UserSurveyStatusModelForFeatureLane;
};

const featureLaneButtonTheme: DeepPartial<FlowbiteButtonTheme> = {
  "size": {
    "xs": "px-1 py-1 text-xs",
  },
};

const ICON_SIZE = "3x";

export default function FeatureLaneButton(
    {
      deliverableGroupId,
      featureId,
      userSurvey,
    }: FeatureLaneButtonProps
) {
  const navigate = useNavigate();

  function buttonClass(userSurvey: UserSurveyStatusModelForFeatureLane) {
    switch (userSurvey.status) {
      case "finished":
        return "text-bc-blue";
      case "in progress":
        return "text-bc-blue";
      case "blocked":
        return "text-neutral-400";
    }
  }

  function buttonIcon(userSurvey: UserSurveyStatusModelForFeatureLane) {
    switch (userSurvey.status) {
      case "finished":
        return <FontAwesomeIcon icon={faCircleCheck} size={ICON_SIZE}/>;
      case "in progress":
        return <FontAwesomeIcon icon={faCircle} size={ICON_SIZE}/>;
      case "blocked":
        return <FontAwesomeIcon icon={faCircle} size={ICON_SIZE}/>;
    }
  }

  return (
      <Button
          theme={featureLaneButtonTheme}
          className={clsx("bg-transparent enabled:hover:bg-transparent", buttonClass(userSurvey))}
          size="xs"
          onClick={() => navigate(surveyQuestionPath(
              deliverableGroupId,
              featureId,
              userSurvey.id,
              "first",
            ))}
          disabled={userSurvey.status === 'blocked'}
      >
        {buttonIcon(userSurvey)}
      </Button>
  );
}
